import { createMuiTheme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
var theme = createMuiTheme({
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '*': {
                    margin: 0,
                    boxSizing: 'border-box',
                },
                'html, body': {
                    width: '100%',
                    height: '100%',
                    lineHeight: 1,
                    backgroundColor: grey[50],
                },
                'h1, h2, h3, h4, h5, h6': {
                    margin: 0,
                },
                '#app': {
                    width: '100%',
                    height: '100%',
                },
                'fieldset.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(120, 136, 150, 1)',
                },
            },
        },
    },
    palette: {
        error: {
            main: 'rgb(211, 69, 91)',
        },
        whimsical: {
            light: '#bab4f9',
            main: '#6558f5',
            dark: '#595caa',
            contrastText: 'rgba(41, 56, 69, 1',
        },
        whimsicalBlue: {
            light: 'rgba(44, 136, 217, 0.42)',
            main: 'rgba(44, 136, 217, 0.74)',
            dark: 'rgba(44, 136, 217, 1)',
            contrastText: 'rgba(41, 56, 69, 1',
        },
        neutral: {
            main: 'rgb(26, 174, 159)',
            dark: 'rgb(32, 120, 104)',
        },
        highlight: {
            main: 'rgb(232, 131, 58)',
        },
        mono: {
            light: 'rgba(221, 230, 237, 1)',
            main: 'rgba(120, 136, 150, 0.54)',
        },
        text: {
            primary: 'rgba(41, 56, 69, 1)',
            //secondary: 'rgba(75, 92, 107, 1)',
            secondary: 'rgba(120, 136, 150, 1)',
            disabled: 'rgba(195, 207, 217, 1)',
            hint: 'rgba(0, 0, 0, 0.38)',
        },
    },
    typography: {
        button: {
            textTransform: 'none',
        },
    },
});
export default theme;
